/**
 * gamesStyles.js
 *
 * Статичные стили раздела «Игры» (plain objects, как в studentInfo/styles.js).
 * Динамика hover/pressed — через функции *Style(state).
 */

import {
  color_grey_ultra_light,
  color_red_default,
  color_white,
} from "../../../constants/colors";
import {
  GAMES_BANNER_HEIGHT,
  GAMES_BORDER_RADIUS_LG,
  GAMES_BORDER_RADIUS_MD,
  GAMES_GRID_GAP,
  GAMES_MOBILE_GRID_GAP,
  GAMES_SECTION_GAP,
  GAMES_TILE_MAX_WIDTH,
  GAMES_TILE_MIN_WIDTH,
} from "./gamesConstants";

// ─── GamesPage ───────────────────────────────────────────────

export const gamesPageStyles = {
  page: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    height: "100%",
  },

  content: {
    display: "flex",
    flexDirection: "column",
    gap: GAMES_SECTION_GAP,
    height: "auto",
  },

  sectionTitle: {
    marginTop: 8,
  },

  desktopGrid: {
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: GAMES_GRID_GAP,
    width: "100%",
  },

  mobileGrid: (justifyContent) => ({
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap",
    gap: GAMES_MOBILE_GRID_GAP,
    justifyContent,
  }),
};

// ─── FeaturedGameBanner ──────────────────────────────────────

export const getBannerContainerStyle = ({ hovered, pressed }) => ({
  position: "relative",
  width: "100%",
  height: GAMES_BANNER_HEIGHT,
  borderRadius: GAMES_BORDER_RADIUS_LG,
  cursor: "pointer",
  flexShrink: 0,
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  transform: pressed ? "scale(0.995)" : hovered ? "scale(1.01)" : "scale(1)",
  boxShadow: hovered ? "0 12px 32px rgba(0,0,0,0.16)" : "0 0 0 rgba(0,0,0,0)",
});

export const bannerImageStyle = {
  width: "100%",
  height: "100%",
  objectFit: "cover",
  display: "block",
  borderRadius: GAMES_BORDER_RADIUS_LG,
};

export const bannerOverlayStyle = {
  position: "absolute",
  inset: 0,
  borderRadius: GAMES_BORDER_RADIUS_LG,
  background:
    "linear-gradient(90deg, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 45%, rgba(0,0,0,0.05) 100%)",
  display: "flex",
  flexDirection: "column",
  justifyContent: "flex-end",
  padding: "32px 40px",
  gap: 12,
};

export const bannerTitleStyle = {
  color: color_white,
  fontSize: 32,
};

export const bannerDescriptionStyle = {
  color: color_white,
  maxWidth: 420,
  opacity: 0.95,
};

export const getBannerPlayButtonStyle = ({ btnHovered, btnPressed }) => ({
  marginTop: 8,
  alignSelf: "flex-start",
  border: "none",
  borderRadius: 12,
  padding: "12px 28px",
  transition:
    "transform 0.15s ease, background-color 0.15s ease, box-shadow 0.15s ease",
  transform: btnPressed
    ? "scale(0.97)"
    : btnHovered
      ? "scale(1.04)"
      : "scale(1)",
  backgroundColor: btnPressed ? "#d94343" : color_red_default,
  boxShadow: btnHovered ? "0 6px 16px rgba(240,79,79,0.35)" : "none",
  color: color_white,
  fontFamily: "Onest, sans-serif",
  fontWeight: 700,
  fontSize: 16,
  cursor: "pointer",
});

// ─── GameCoverTile ───────────────────────────────────────────

export const tileContainerStyle = {
  flex: "1 1 0",
  minWidth: GAMES_TILE_MIN_WIDTH,
  maxWidth: GAMES_TILE_MAX_WIDTH,
  display: "flex",
  flexDirection: "column",
  gap: 10,
  cursor: "pointer",
};

export const getTileImageStyle = ({ hovered, pressed }) => ({
  width: "100%",
  aspectRatio: "4 / 3",
  objectFit: "cover",
  borderRadius: GAMES_BORDER_RADIUS_MD,
  backgroundColor: color_grey_ultra_light,
  display: "block",
  transition: "transform 0.2s ease, box-shadow 0.2s ease",
  transform: pressed ? "scale(0.98)" : hovered ? "scale(1.04)" : "scale(1)",
  boxShadow: hovered ? "0 8px 24px rgba(0,0,0,0.12)" : "0 0 0 rgba(0,0,0,0)",
});

export const tileTitleStyle = {
  fontSize: 15,
  lineHeight: 1.3,
};
